import { Level2Wrapper } from '../common/Level2Wrapper';
import { ImageList } from '../common/ImageList';
import { GenericSubSection } from '../common/GenericSubSection';
import { useInteriorGeneralSection } from '../../hooks/useInteriorGeneralSection';

export const InteriorLevel3 = () => {
  const { section, images } = useInteriorGeneralSection();

  return (
    <Level2Wrapper flex="1 1 100%" label="Interior">
      <ImageList label="Interior Pictures" images={images} />
      {Object.values(section?.subsections ?? {}).map(sub => (
        <GenericSubSection key={sub.id} section={sub} />
      ))}
    </Level2Wrapper>
  );
};
